"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineAccountancyDetails = void 0;
const formatShortDate_1 = require("../formatShortDate");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineTitle_1 = require("./getOrderLineTitle");
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const getOrderLineAccountancyDetails = (line, payment_value, // 5040 this has to be EXCL CC FEES
idx) => {
    const items = [];
    if (!line.versions)
        return items;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
    if (!latest_version)
        return items;
    const { type } = line;
    const { config } = latest_version;
    const order_line_total = (0, getOrderLineTotal_1.getOrderLineTotal)(line); // how much the whole order line is:  5600
    const payment_value_as_percentage = payment_value / order_line_total;
    switch (type) {
        case "GOLF": {
            const golf_config = config;
            const has_deposit = golf_config.supplier_deposit.enabled;
            const deposit_amount = golf_config.supplier_deposit.amount / 100;
            /* CARTS */
            const cart_cost = golf_config?.carts?.types
                ? golf_config?.carts?.types.reduce((acc, curr) => acc + curr.cost_per_cart * curr.quantity, 0)
                : 0;
            const cart_deposit = has_deposit ? cart_cost * deposit_amount : 0;
            const cart_vat = golf_config?.carts?.vat;
            const cart_wht = golf_config?.carts?.withholding_tax;
            const cart_input_vat = cart_cost - cart_cost / (1 + cart_vat);
            const cart_output_vat = cart_cost - cart_cost / (1 + cart_vat);
            const cart_input_wht = (cart_cost - cart_input_vat) * cart_wht;
            /* CADDIES */
            const caddie_cost = (golf_config?.caddies?.cost_per_caddie || 0) *
                (golf_config?.caddies?.quantity || 0);
            const caddie_deposit = has_deposit ? caddie_cost * deposit_amount : 0;
            const caddie_vat = golf_config?.caddies?.vat || 0;
            const caddie_wht = golf_config?.caddies?.withholding_tax || 0;
            const caddie_input_vat = caddie_cost - caddie_cost / (1 + (caddie_vat || 0));
            const caddie_output_vat = caddie_cost - caddie_cost / (1 + (caddie_vat || 0));
            const caddie_input_wht = (caddie_cost - caddie_input_vat) * (caddie_wht || 0);
            /* GREEN FEE */
            let green_fee_cost = golf_config?.green_fee?.cost *
                golf_config.where_when_who?.number_of_golfers +
                golf_config?.green_fee?.odd_number_surcharge;
            if (golf_config?.product.config && golf_config?.product.config.caddie) {
                green_fee_cost = green_fee_cost - caddie_cost;
            }
            if (golf_config?.product.config &&
                (golf_config?.product.config.shared_cart ||
                    golf_config?.product.config.single_cart)) {
                green_fee_cost = green_fee_cost - cart_cost;
            }
            const green_fee_margin = golf_config?.green_fee?.margin *
                golf_config.where_when_who?.number_of_golfers;
            const green_fee_sell = green_fee_cost + green_fee_margin;
            const green_fee_deposit = has_deposit
                ? (green_fee_cost + green_fee_margin) * deposit_amount
                : 0;
            const green_fee_vat = golf_config?.green_fee?.vat;
            const green_fee_wht = golf_config?.green_fee?.withholding_tax;
            const green_fee_input_vat = green_fee_cost - green_fee_cost / (1 + green_fee_vat);
            const green_fee_output_vat = green_fee_sell - green_fee_sell / (1 + green_fee_vat);
            const green_fee_input_wht = (green_fee_cost - green_fee_input_vat) * green_fee_wht;
            items.push({
                name: "GREEN_FEE",
                cost: green_fee_cost * payment_value_as_percentage,
                margin: green_fee_margin * payment_value_as_percentage,
                sell: green_fee_sell * payment_value_as_percentage,
                deposit: green_fee_deposit * payment_value_as_percentage,
                supplier_vat: green_fee_vat * payment_value_as_percentage,
                supplier_wht: green_fee_wht * payment_value_as_percentage,
                input_vat: green_fee_input_vat * payment_value_as_percentage,
                output_vat: green_fee_output_vat * payment_value_as_percentage,
                wht: green_fee_input_wht * payment_value_as_percentage,
                supplier_id: golf_config?.supplier?.id,
                service_date: latest_version.start_date,
                group_id: idx,
                group_name: `${(0, getOrderLineTitle_1.getOrderLineTitle)(line)} - (${(0, formatShortDate_1.formatShortDate)(latest_version.start_date)})`,
            });
            if (golf_config?.carts?.enabled &&
                golf_config?.carts.payment_option !== "ON_ARRIVAL") {
                items.push({
                    name: "CART",
                    cost: cart_cost * payment_value_as_percentage,
                    margin: 0,
                    sell: cart_cost * payment_value_as_percentage,
                    deposit: cart_deposit * payment_value_as_percentage,
                    supplier_vat: cart_vat * payment_value_as_percentage,
                    supplier_wht: cart_wht * payment_value_as_percentage,
                    input_vat: cart_input_vat * payment_value_as_percentage,
                    output_vat: cart_output_vat * payment_value_as_percentage,
                    wht: cart_input_wht * payment_value_as_percentage,
                    supplier_id: golf_config?.supplier?.id,
                    service_date: latest_version.start_date,
                    group_id: idx,
                    group_name: `${(0, getOrderLineTitle_1.getOrderLineTitle)(line)} - (${(0, formatShortDate_1.formatShortDate)(latest_version.start_date)})`,
                });
            }
            if (golf_config?.caddies?.enabled &&
                golf_config?.caddies.payment_option !== "ON_ARRIVAL") {
                items.push({
                    name: "CADDIE",
                    cost: caddie_cost * payment_value_as_percentage,
                    margin: 0 * payment_value_as_percentage,
                    sell: caddie_cost * payment_value_as_percentage,
                    deposit: caddie_deposit * payment_value_as_percentage,
                    supplier_vat: caddie_vat * payment_value_as_percentage,
                    supplier_wht: caddie_wht * payment_value_as_percentage,
                    input_vat: caddie_input_vat * payment_value_as_percentage,
                    output_vat: caddie_output_vat * payment_value_as_percentage,
                    wht: caddie_input_wht * payment_value_as_percentage,
                    supplier_id: golf_config?.supplier?.id,
                    service_date: latest_version.start_date,
                    group_id: idx,
                    group_name: `${(0, getOrderLineTitle_1.getOrderLineTitle)(line)} - (${(0, formatShortDate_1.formatShortDate)(latest_version.start_date)})`,
                });
            }
            break;
        }
        case "HOTEL": {
            const hotel_config = config;
            const has_deposit = hotel_config.supplier_deposit.enabled;
            const deposit_amount = hotel_config.supplier_deposit.amount / 100;
            // calculate the total of hotel_config rooms.rooms total
            const hotel_cost = hotel_config.rooms.rooms.reduce((acc, room) => {
                const rate_total = room.rate.reduce((acc, rate) => {
                    return acc + rate.sell_price + rate.board_surcharge;
                }, 0);
                return acc + rate_total;
            }, 0);
            // TODO - calculate the margin
            const hotel_margin = hotel_config.rooms.rooms.reduce((acc, room) => {
                const rate_margin = room.rate.reduce((acc, rate) => {
                    return acc + rate.margin;
                }, 0);
                return acc + rate_margin;
            }, 0);
            const hotel_sell = hotel_cost + hotel_margin;
            const hotel_deposit = has_deposit
                ? (hotel_cost + hotel_margin) * deposit_amount
                : 0;
            const hotel_vat = hotel_config?.rooms?.vat;
            const hotel_wht = hotel_config?.rooms?.withholding_tax;
            const hotel_input_vat = hotel_cost - hotel_cost / (1 + hotel_vat);
            const hotel_output_vat = hotel_sell - hotel_sell / (1 + hotel_vat);
            const hotel_input_wht = (hotel_cost - hotel_input_vat) * hotel_wht;
            items.push({
                name: "HOTEL",
                cost: hotel_cost * payment_value_as_percentage,
                margin: hotel_margin * payment_value_as_percentage,
                sell: hotel_sell * payment_value_as_percentage,
                deposit: hotel_deposit * payment_value_as_percentage,
                supplier_vat: hotel_vat * payment_value_as_percentage,
                supplier_wht: hotel_wht * payment_value_as_percentage,
                input_vat: hotel_input_vat * payment_value_as_percentage,
                output_vat: hotel_output_vat * payment_value_as_percentage,
                wht: hotel_input_wht,
                supplier_id: hotel_config?.supplier?.id,
                service_date: latest_version.start_date,
                group_id: idx,
                group_name: `${(0, getOrderLineTitle_1.getOrderLineTitle)(line)} - (${(0, formatShortDate_1.formatShortDate)(latest_version.start_date)})`,
            });
            break;
        }
        case "TRANSFER": {
            const transfer_config = config;
            const has_deposit = transfer_config.supplier_deposit.enabled;
            const deposit_amount = transfer_config.supplier_deposit.amount / 100;
            const transfer_cost = transfer_config.vehicle
                ? transfer_config.vehicle.cost * transfer_config.vehicle.quantity
                : 0;
            const transfer_margin = transfer_config.vehicle
                ? transfer_config?.vehicle?.margin * transfer_config.vehicle.quantity
                : 0;
            const transfer_sell = transfer_cost + transfer_margin;
            const transfer_deposit = has_deposit
                ? (transfer_cost + transfer_margin) * deposit_amount
                : 0;
            const transfer_vat = transfer_config?.vehicle?.vat || 0;
            const transfer_wht = transfer_config?.vehicle?.withholding_tax || 0;
            const transfer_input_vat = transfer_cost - transfer_cost / (1 + (transfer_vat || 0));
            const transfer_output_vat = transfer_sell - transfer_sell / (1 + (transfer_vat || 0));
            const transfer_input_wht = (transfer_cost - transfer_input_vat) * (transfer_wht || 0);
            items.push({
                name: "TRANSFER",
                cost: transfer_cost * payment_value_as_percentage,
                margin: transfer_margin * payment_value_as_percentage,
                sell: transfer_sell * payment_value_as_percentage,
                deposit: transfer_deposit * payment_value_as_percentage,
                supplier_vat: transfer_vat * payment_value_as_percentage,
                supplier_wht: transfer_wht * payment_value_as_percentage,
                input_vat: transfer_input_vat * payment_value_as_percentage,
                output_vat: transfer_output_vat * payment_value_as_percentage,
                wht: transfer_input_wht * payment_value_as_percentage,
                supplier_id: transfer_config?.supplier?.id,
                service_date: latest_version.start_date,
                group_id: idx,
                group_name: `${(0, getOrderLineTitle_1.getOrderLineTitle)(line)} - (${(0, formatShortDate_1.formatShortDate)(latest_version.start_date)})`,
            });
            break;
        }
        case "CUSTOM": {
            const custom_config = config;
            const has_deposit = custom_config.supplier_deposit.enabled;
            const deposit_amount = custom_config.supplier_deposit.amount / 100;
            const custom_cost = custom_config.pricing.cost * custom_config.pricing.quantity;
            const custom_margin = custom_config.pricing.margin * custom_config.pricing.quantity;
            const custom_sell = custom_cost + custom_margin;
            const custom_deposit = has_deposit
                ? (custom_cost + custom_margin) * deposit_amount
                : 0;
            const custom_vat = custom_config?.pricing?.vat;
            const custom_wht = custom_config?.pricing?.withholding_tax;
            const custom_input_vat = custom_cost - custom_cost / (1 + custom_vat);
            const custom_output_vat = custom_sell - custom_sell / (1 + custom_vat);
            const custom_input_wht = (custom_cost - custom_input_vat) * custom_wht;
            items.push({
                name: "CUSTOM",
                cost: custom_cost * payment_value_as_percentage,
                margin: custom_margin * payment_value_as_percentage,
                sell: custom_sell * payment_value_as_percentage,
                deposit: custom_deposit * payment_value_as_percentage,
                supplier_vat: custom_vat * payment_value_as_percentage,
                supplier_wht: custom_wht * payment_value_as_percentage,
                input_vat: custom_input_vat * payment_value_as_percentage,
                output_vat: custom_output_vat * payment_value_as_percentage,
                wht: custom_input_wht * payment_value_as_percentage,
                supplier_id: custom_config?.supplier?.id,
                service_date: latest_version.start_date,
                group_id: idx,
                group_name: `${(0, getOrderLineTitle_1.getOrderLineTitle)(line)} - (${(0, formatShortDate_1.formatShortDate)(latest_version.start_date)})`,
            });
            break;
        }
    }
    return items;
};
exports.getOrderLineAccountancyDetails = getOrderLineAccountancyDetails;
